// ================================
// ドロワーメニュー（既存コード）
// ================================
document.addEventListener("DOMContentLoaded", function () {
  const menuButton = document.querySelector(".menu-toggle");
  const menuDrawer = document.getElementById("menuDrawer");
  const closeButton = document.querySelector(".menu-drawer__close");

  if (!menuButton || !menuDrawer) return;

  const openMenu = () => {
    menuDrawer.classList.add("is-open");
    menuDrawer.setAttribute("aria-hidden", "false");
  };

  const closeMenu = () => {
    document.activeElement.blur(); // アクセシビリティ対策
    menuDrawer.classList.remove("is-open");
    menuDrawer.setAttribute("aria-hidden", "true");
  };

  menuButton.addEventListener("click", openMenu);
  if (closeButton) closeButton.addEventListener("click", closeMenu);

  // ESCキーで閉じる
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && menuDrawer.classList.contains("is-open")) {
      closeMenu();
    }
  });
});


// ================================
// 最近チェックした商品（追加部分）
// ================================
document.addEventListener("DOMContentLoaded", function () {
  // product オブジェクトが Liquid から出力されているページだけ実行
  const productHandleEl = document.querySelector('[data-product-handle]');
  const recentContainer = document.getElementById("recent-products-list");
  if (!productHandleEl && !recentContainer) return;

  // 商品ページの場合：localStorage に保存
  if (productHandleEl) {
    const productHandle = productHandleEl.dataset.productHandle;
    const productTitle = productHandleEl.dataset.productTitle;
    const productImage = productHandleEl.dataset.productImage;
    const productPrice = productHandleEl.dataset.productPrice;
    const productUrl = productHandleEl.dataset.productUrl;

    let viewed = JSON.parse(localStorage.getItem("recentProducts")) || [];
    viewed = viewed.filter(p => p.handle !== productHandle);
    viewed.unshift({
      handle: productHandle,
      title: productTitle,
      image: productImage,
      price: productPrice,
      url: productUrl
    });
    viewed = viewed.slice(0, 4);
    localStorage.setItem("recentProducts", JSON.stringify(viewed));
  }

  // 一覧を表示（トップや商品ページ下部など）
  if (recentContainer) {
    const viewed = JSON.parse(localStorage.getItem("recentProducts")) || [];
    if (viewed.length === 0) {
      recentContainer.innerHTML = "<p>最近チェックした商品はありません。</p>";
      return;
    }

    recentContainer.innerHTML = viewed
      .map(
        p => `
          <a href="${p.url}" class="recent-products__item">
            <img src="${p.image}" alt="${p.title}">
            <p class="recent-products__title">${p.title}</p>
            <p class="recent-products__price">${p.price}</p>
          </a>
        `
      )
      .join("");
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const thumbSlider = new Swiper(".product-thumb-slider", {
    spaceBetween: 8,
    slidesPerView: "auto",
    watchSlidesProgress: true,
  });

  const mainSlider = new Swiper(".product-main-slider", {
    spaceBetween: 10,
    effect: "slide",
    loop: false,
    thumbs: {
      swiper: thumbSlider,
    },
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const quantityForms = document.querySelectorAll("form.cart-form, .product-detail form");

  quantityForms.forEach((form) => {
    const minus = form.querySelector(".qty-btn.minus");
    const plus = form.querySelector(".qty-btn.plus");
    const input = form.querySelector(".qty-input");

    if (!minus || !plus || !input) return;

    minus.addEventListener("click", (e) => {
      e.preventDefault();
      let current = parseInt(input.value) || 1;
      if (current > 1) {
        input.value = current - 1;
        input.dispatchEvent(new Event("change")); // Shopify連携用
      }
    });

    plus.addEventListener("click", (e) => {
      e.preventDefault();
      let current = parseInt(input.value) || 1;
      input.value = current + 1;
      input.dispatchEvent(new Event("change")); // Shopify連携用
    });
  });
});

// ===============================
// カートバッジ自動更新処理（中央揃え対応）
// ===============================
document.addEventListener("DOMContentLoaded", function() {
  const cartBadge = document.getElementById("cart-count");

  // 🛒 カートの数量を取得してバッジ更新
  function updateCartCount() {
    fetch("/cart.js")
      .then(res => res.json())
      .then(data => {
        const count = data.item_count;

        if (count > 0) {
          cartBadge.textContent = count;

          // flex配置を維持したまま表示（display切替ではなくvisibility使用）
          cartBadge.classList.add("visible");

          // ポンッとアニメーション
          cartBadge.classList.add("pop");
          setTimeout(() => cartBadge.classList.remove("pop"), 300);
        } else {
          cartBadge.classList.remove("visible");
        }
      })
      .catch(err => console.error("カート情報取得エラー:", err));
  }

  // ページ読み込み時に反映
  updateCartCount();

  // カート追加フォームを監視
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener("submit", () => {
      setTimeout(updateCartCount, 800);
    });
  });

  // ShopifyテーマのAjaxカート（ドロワーなど）にも対応
  document.addEventListener("cart:refresh", updateCartCount);
});

